const features = {
  'features-breadcrumbs-daily': 'Ежедневные',
  'features-breadcrumbs-editors-choice': 'Выбор редакторов',
  'features-breadcrumbs-external-promo': 'Внешние промо',
  'features-table-featured-column': 'Показ в рекомендуемых',
  'features-create-title': 'Создание данных',
  'features-update-title': 'Редактировать данные',
  'features-form-collapse-title-targets': 'Назначение',
  'features-form-image-id-label': 'ID изображения',
  'features-form-show-featured-label': 'Показ в рекомендуемых',
  'features-utc': 'UTC+0',
  'features-title-info': 'Если данное поле оставить не заполненным, то оно заполнится автоматически',
  'features-title-use-automatic-generation-info': 'Заголовок генерируется автоматически',
  'features-show-in-features-info': 'Отображать сущность в разделе контента в мобильном приложении (Слайдер в верхней части экрана)',
  'features-details-unpublish': 'Снять с публикации из HC',
  'features-edit-images-to-attach': 'Изображения готовые для использования',
  'features-edit-images-to-attach-confirm-message': 'Вы уверены, что хотите использовать данное изображение? Все несохраненные изменения будут удалены.',
  'features-edit-images-to-attach-published-daily-cancel': 'Вы не можете поменять изображение у опубликованного Ежедневного. Для изменения снимите Ежедневное с публикации.',
  'features-edit-images-to-attach-success': 'Изображение успешно прикреплено',
  'features-edit-images-to-attach-failed': 'Не удалось прикрепить изображение',
  'features-unpublish-failed': 'Ошибка при снятии с публикации',
  'features-edit-publish-to-hc': 'Опубликовать изменения в HappyColor',
  'features-not-featured-tag': 'Не в рекомендациях',
  'features-disabled-template-text-error': 'Шаблон выключен. Для того чтобы включить сущность, сперва включите шаблон.',
  'features-publish-notification-note': 'Публикация запрещена, в случае когда к сущности не прикреплено ни одного изображения.',
  'features-daily-change-released-at-warning-note': 'Вы не можете обновить поле «Релиз с», Ежедневное находится в производстве для всего мира или его части.',
  'features-unpublish-used-notification': 'Нельзя снять с публикации фичер, привязанный к событию',
};

export default features;
